Namespace 'Settings.Views.Topics'

class Settings.Views.Topics.SourceView extends Backbone.View
  template: JST['backbone/templates/settings/topics/source']
  tagName: 'tr'
  className: 'animated-container hidden'

  events:
    'click .create-source': 'createSource'

  initialize: ({socialAccounts, sourceListEl, newSourceButtonsEl}) ->
    @socialAccounts = socialAccounts
    @sourceListEl = sourceListEl
    @newSourceButtonsEl = newSourceButtonsEl

  render: ->
    @$el.html @template
      sourceIcon: @icon
      socialAccounts: @socialAccounts
      type: @type
    @

  createSource: ->
    selectedSocialAccount = @$el.find('.channel_fields #social_account option:selected')
    socialAccountName = selectedSocialAccount.text()
    socialAccountId = selectedSocialAccount.val()
    @$el.addClass('hidden')
    @channelView = new @channelViewClass
      sourceIndex: Date.now()
      socialAccountName: socialAccountName
      socialAccountId: socialAccountId
      allowRemove: true
    @sourceListEl.prepend(@channelView.render().el)
    @showAndDisableNewSourceButtons()

  showAndDisableNewSourceButtons: ->
    @newSourceButtonsEl.fadeIn()
    _.each(@newSourceButtonsEl.find('.source-link'), (item) -> $(item).addClass('disabled'))
